// extracted by mini-css-extract-plugin
module.exports = {"branding":"styles__branding___3muoG","brandingImg":"styles__brandingImg___1VAIb"};